import { useState, useEffect } from 'react';
import BackButton from '../components/BackButton';
import { useApp } from '../App';
import api from '../api';
import Loading from '../components/Loading';
import CompanyGate from '../components/CompanyGate';
import { useI18n } from '../i18n/index.jsx';

function WithdrawalsInner() {
  const { currentCompany } = useApp();
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ amount: '', payout_method: 'bank', bank_account: '', wallet_address: '', notes: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const { data } = await api.get('/withdrawals');
      setItems(data);
    } catch {}
    setLoading(false);
  }

  async function create() {
    setMsg('');
    const amount = Number(form.amount);
    if (!amount || amount <= 0) return setMsg(t('withdrawals.enter_amount'));

    const isCrypto = form.payout_method === 'crypto';
    if (isCrypto && !form.wallet_address) return setMsg(t('withdrawals.enter_wallet'));

    const bank_account = isCrypto ? null : (form.bank_account || null);
    const notes = [
      form.notes?.trim(),
      isCrypto ? `CRYPTO: TRC-20 | WALLET: ${form.wallet_address}` : null,
    ].filter(Boolean).join(' | ') || null;

    try {
      await api.post('/withdrawals', {
        company_id: currentCompany?.id,
        amount,
        bank_account,
        notes,
      });
      setMsg('✅ ' + t('withdrawals.request_sent'));
      setShowForm(false);
      load();
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  const statusLabels = {
    requested: '⏳ ' + t('withdrawals.status_requested'),
    approved: '✅ ' + t('withdrawals.status_approved'),
    paid: '💸 ' + t('withdrawals.status_paid'),
    rejected: '❌ ' + t('withdrawals.status_rejected'),
  };

  if (loading) return <Loading />;

  if (showForm) {
    const amt = Number(form.amount) || 0;
    const commission = (amt * 0.06).toFixed(2);
    const net = (amt - amt * 0.06).toFixed(2);
    return (
      <div className="page">
      <BackButton />
        <h1>💸 {t('withdrawals.title')}</h1>
        <div className="form">
          <div className="field"><label>{t('withdrawals.amount_label')}</label>
            <input type="number" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} /></div>

          <div className="field">
            <label>{t('withdrawals.method_label')}</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                className={`btn btn-small ${form.payout_method === 'bank' ? 'btn-primary' : ''}`}
                onClick={() => setForm({ ...form, payout_method: 'bank' })}
                type="button"
                style={{ flex: 1 }}
              >{t('withdrawals.method_bank')}</button>
              <button
                className={`btn btn-small ${form.payout_method === 'crypto' ? 'btn-primary' : ''}`}
                onClick={() => setForm({ ...form, payout_method: 'crypto' })}
                type="button"
                style={{ flex: 1 }}
              >{t('withdrawals.method_crypto')}</button>
            </div>
          </div>

          {amt > 0 && (
            <div className="detail-card" style={{ margin: '8px 0' }}>
              <div>{t('withdrawals.commission_label')}: <b>{commission} PLN</b></div>
              <div>{t('withdrawals.to_receive')}: <b>{net} PLN</b></div>
            </div>
          )}

          {form.payout_method === 'bank' ? (
            <div className="field"><label>{t('withdrawals.bank_account')}</label>
              <input value={form.bank_account} onChange={e => setForm({ ...form, bank_account: e.target.value })} placeholder="PL XX XXXX XXXX XXXX XXXX XXXX XXXX" /></div>
          ) : (
            <div className="field"><label>{t('withdrawals.crypto_wallet')}</label>
              <input value={form.wallet_address} onChange={e => setForm({ ...form, wallet_address: e.target.value })} placeholder="Txxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" /></div>
          )}

          <div className="field"><label>{t('withdrawals.note')}</label>
            <input value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} /></div>
        </div>
        {msg && <div className="message">{msg}</div>}
        <div className="actions">
          <button className="btn btn-primary" onClick={create}>📤 {t('withdrawals.send_request')}</button>
          <button className="btn btn-secondary" onClick={() => setShowForm(false)}>{t('common.cancel')}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <BackButton />
      <h1>💸 {t('withdrawals.title')}</h1>
      <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ {t('withdrawals.new_request')}</button>
      {items.length === 0 ? <div className="empty">{t('withdrawals.no_requests')}</div> :
        <div className="list">
          {items.map(w => (
            <div key={w.id} className="list-item">
              <div className="list-main">
                <div className="list-title">{Number(w.amount).toFixed(2)} PLN</div>
                <div className="list-sub">{t('withdrawals.commission_detail')}: {Number(w.commission_amount).toFixed(2)} • {t('withdrawals.payout_detail')}: {Number(w.net_amount).toFixed(2)}</div>
              </div>
              <div className={`status-badge status-${w.status}`}>{statusLabels[w.status] || w.status}</div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default function Withdrawals() {
  return <CompanyGate><WithdrawalsInner /></CompanyGate>;
}
